import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { flatten } from 'lodash';
import { useMutaionRequestInvoice } from 'containers/SettlementRequest/graphQL/hooks/useMutationRequestInvoice';
import { SettlementsNode } from 'containers/SettlementRequest/graphQL/types';
import { useQuerySettlementListByFilter } from '../graphQL/hooks/useQuerySettlementListByFilter';

export const useSettlementListHook = () => {
  const {
    settlementList,
    selectedSettlement,
    setSelectedSettlement,
    isShowRequireInvoice,
    refetchSettlementList,
    handleShowRequireInvoice,
  } = useQuerySettlementListByFilter();
  const { handleRequestInvoices } = useMutaionRequestInvoice();

  const [isOpenSearchModal, setIsOpenSearchModal] = useState<boolean>(false);
  const [isOpenRequestModal, setIsOpenRequestModal] = useState<boolean>(false);
  const [termType, setTermType] = useState<string>('all');

  const handleSelectSettlement = (settlement: SettlementsNode) => {
    if (settlement.invoice !== null) {
      return;
    }

    if (selectedSettlement.includes(settlement)) {
      const filterItem = selectedSettlement.filter(
        item => item.id !== settlement.id,
      );

      setSelectedSettlement(filterItem);

      return;
    }

    setSelectedSettlement([...selectedSettlement, settlement]);
  };

  const handleSetTermType = (type: string) => {
    setTermType(type);
  };

  const handleResetTermType = () => {
    setTermType('all');
  };

  const handleAcceptFilter = () => {
    let filter = { term: { endedAt: 0, startedAt: 0 } };
    const today = new Date();

    switch (termType) {
      case 'all': {
        filter.term = null;

        break;
      }
      case '1month': {
        const startedAt = new Date(today);
        startedAt.setMonth(startedAt.getMonth() - 1);

        filter.term.startedAt = startedAt.getTime();
        filter.term.endedAt = today.getTime();

        break;
      }
      case '6month': {
        const startedAt = new Date(today);
        startedAt.setMonth(startedAt.getMonth() - 6);

        filter.term.startedAt = startedAt.getTime();
        filter.term.endedAt = today.getTime();

        break;
      }
      case '1year': {
        const startedAt = new Date(today);
        startedAt.setFullYear(startedAt.getFullYear() - 1);

        filter.term.startedAt = startedAt.getTime();
        filter.term.endedAt = today.getTime();

        break;
      }
      case '5year': {
        const startedAt = new Date(today);
        startedAt.setFullYear(startedAt.getFullYear() - 5);

        filter.term.startedAt = startedAt.getTime();
        filter.term.endedAt = today.getTime();

        break;
      }
    }

    if (isShowRequireInvoice) {
      handleShowRequireInvoice();
    }
    refetchSettlementList(filter);
  };

  return {
    settlementList,
    selectedSettlement,
    termType,
    isOpenSearchModal,
    isOpenRequestModal,
    isShowRequireInvoice,
    setIsOpenRequestModal,
    setIsOpenSearchModal,
    handleSetTermType,
    handleResetTermType,
    handleAcceptFilter,
    handleSelectSettlement,
    handleRequestInvoices,
    refetchSettlementList,
    handleShowRequireInvoice,
  };
};
